module.exports = __webpack_public_path__ + "img/sogatella-furcifera.857b3e73.jpg";